/**
 * DWEB-204 — the ONE footer height, read back from the ONE declaration.
 *
 * The same value does two jobs, and they must agree to the pixel:
 *
 *   index.css   #root reserves it as padding-bottom, so at maximum scroll the
 *               last band of the document is empty space, not content
 *   Footer.js   the footer rises when that many pixels remain below the fold,
 *               so it fills exactly the band that was reserved
 *
 * Before this, the reveal rose at min(30% of the viewport, 300px) — a number
 * with no relation to the footer — and nothing reserved anything. Two copies
 * of a height that disagree is the defect; this is the DWEB-180 answer to it,
 * mirroring src/utils/headerHeight.js.
 *
 * There is deliberately no numeric fallback, for the reason headerHeight.js
 * and the --glass-bg block in index.css give: a fallback is the second copy,
 * and it is the copy that hides the failure. If the declaration ever goes
 * missing this returns 0, the footer rises only at the very bottom over
 * unreserved content, and e2e/footer-height.spec.js says so.
 */

/** The declared footer height in px, read from :root at call time. */
export function footerHeight() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return 0;
  const declared = getComputedStyle(document.documentElement).getPropertyValue('--footer-height');
  const px = parseFloat(declared);
  return Number.isFinite(px) ? px : 0;
}
